import isEqual from 'lodash.isequal';
import { NO_AXIS_SELECTED_VALUE } from './constants';
import { getDataRequestedConfig } from './getDataRequestedConfig';
import type { RequestedConfig, Chart } from './types';

export const isRequestedConfigEqual = (
  requestedConfig: RequestedConfig<Chart> | null | undefined,
  chart: Chart,
) => {
  if (!requestedConfig) {
    return false;
  }

  if (chart.secondaryMetric === NO_AXIS_SELECTED_VALUE) {
    const { secondaryMetric, ...cleanedRequestedConfig } = requestedConfig;
    const { secondaryMetric: _, ...cleanedChartConfig } =
      getDataRequestedConfig(chart);

    return isEqual(cleanedRequestedConfig, cleanedChartConfig);
  }

  return isEqual(requestedConfig, getDataRequestedConfig(chart));
};
